import { Text } from '@heathmont/moon-components';
import styled from 'styled-components';

type Props = {
  label: string;
};

const TermsText = styled(Text)`
  && a {
    text-decoration: underline;
    color: ${({ theme }) => theme.color.bulma[100]};
  }
`;

const IAgreeToTermsText: FC<Props> = ({ label }) => (
  <TermsText
    size={12}
    color="trunks.100"
    dangerouslySetInnerHTML={{ __html: label }}
  />
);

export default IAgreeToTermsText;
